import {useEffect,useMemo,useState} from 'react';
import {createInventoryApi} from './inventoryApi.mjs';
import {getStoredUser} from '../../utils/auth';
import {canUsePicking,isInventoryOwner} from '../../utils/inventoryNavigation.mjs';
import {pickQueueSummary} from './pickQueueSummary.mjs';

const snapshots=new Map();
export default function PickQueueBadge({user}){
 const [snapshot,setSnapshot]=useState(null),api=useMemo(()=>createInventoryApi({getAccessToken:()=>getStoredUser()?.accessToken}),[]);
 const email=String(user?.email||'').trim().toLowerCase(),enabled=canUsePicking(user);
 useEffect(()=>{
  if(!enabled)return;let active=true;
  async function update(){
   if(document.visibilityState==='hidden')return;
   let entry=snapshots.get(email);
   if(!entry||Date.now()-entry.at>20000){entry={at:Date.now(),promise:api.picks({operation:'summary'})};snapshots.set(email,entry);}
   try{const value=await entry.promise;if(active)setSnapshot({email,value});}catch{snapshots.delete(email);}
  }
  update();const timer=setInterval(update,30000);window.addEventListener('focus',update);
  return()=>{active=false;clearInterval(timer);window.removeEventListener('focus',update);};
 },[api,email,enabled]);
 const summary=pickQueueSummary(snapshot?.email===email?snapshot.value:null,isInventoryOwner(user));
 if(!enabled||!summary)return null;
 return <span aria-label={summary.description} title={summary.description} className="rc-badge rc-badge--accent">{summary.text}</span>;
}
